import { forwardRef } from 'react';

import { OmitStrict } from '../../../types';
import IconButton, { IconButtonProps } from '../../IconButton/IconButton';

type Props = OmitStrict<IconButtonProps, 'size' | 'variant'>;

const DataTableActionButton = forwardRef<HTMLButtonElement, Props>(
  (props, ref) => (
    <IconButton {...props} ref={ref} size="small" variant="simple" />
  ),
);

DataTableActionButton.displayName = 'DataTableActionButton';

export default DataTableActionButton;
